import * as React from "react";
import { Box } from "@mui/material";
import StackList from "./stackList";
import { formatCurrency } from "../utils";
import KeyValueText, { IKeyValueText } from "./KeyValueText";
import { useTranslation } from "react-i18next";
import { useGlobalContext } from "../context/globalContext";

const ServiceChargeSummary = ({ ...rest }) => {
  const { t } = useTranslation();
  const { totalAmount, totalFees } = useGlobalContext();

  const listData: IKeyValueText[] = [
    // {
    //   title: t("payment.form.amount"),
    //   value: formatCurrency(amount),
    // },
    {
      title: t("payment.form.total_charge"),
      value: formatCurrency(totalFees),
    },
  ];
  return (
    <Box
      sx={{ bgcolor: "#E2E2E2", py: 1.5, mt: -4, borderRadius: 1 }}
      {...rest}
    >
      <StackList spacing={2} list={listData} margin={2} />
      <KeyValueText
        title={t("payment.form.total_amount")}
        value={formatCurrency(totalAmount)}
        valueStyles={{
          fontSize: 30,
          color: "#D92D20",
          fontWeight: "600",
          marginTop: 2,
          marginRight: 2,
        }}
        titleStyles={{ fontSize: 20, color: "black", marginLeft: 2 }}
      />
    </Box>
  );
};

export default ServiceChargeSummary;
